export function submitOpenBankingPayoutV1(send) {
  return (body, ...args) =>
    send(
      {
        path: '/v1/openbanking/payouts',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
